var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMappin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 28,
    viewBox: "0 0 29 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.0802 2.33325C8.9255 2.33325 4.74683 7.00293 4.74683 12.2499C4.74683 17.4558 7.7257 23.1144 12.3734 25.2868C13.4569 25.7932 14.7035 25.7932 15.7869 25.2868C20.4346 23.1144 23.4135 17.4558 23.4135 12.2499C23.4135 7.00293 19.2348 2.33325 14.0802 2.33325ZM14.0802 13.9999C15.3688 13.9999 16.4135 12.9552 16.4135 11.6666C16.4135 10.3779 15.3688 9.33325 14.0802 9.33325C12.7915 9.33325 11.7468 10.3779 11.7468 11.6666C11.7468 12.9552 12.7915 13.9999 14.0802 13.9999Z",
    fill: "#EEE82C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMappin);
export default __webpack_public_path__ + "static/media/mappin.9311b0e3f7f7e4ba8aa2064d9117ecac.svg";
export { ForwardRef as ReactComponent };